module.exports = __webpack_public_path__ + "static/media/G1141311_Korea-14.d4646b0f.png";